<p *ngIf="user; else noUser" [nucTooltip]="user.fullName">
    {{user.fullName | initials}}
</p>

<ng-template #noUser>
    <p>?</p>
</ng-template>
